import { gql } from '@apollo/client';

export default gql`
  mutation UploadCompanyUserAvatar(
    $first_name: String!
    $last_name: String!
    $email: Email!
    $position: String
    $avatar: String
  ) {
    updateCompanyUserProfile(
      avatar: $avatar
      first_name: $first_name
      last_name: $last_name
      email: $email
      position: $position
    )
  }
`;
